import BaseEntityCard from '../components/sites/BaseEntityCard';
import {mapGetters} from 'vuex';
import _ from 'lodash';

export default {
  components: {
    BaseEntityCard
  },

  props: {
    id: String
  },

  data() {
    return {
      isValid: false,
      entity: this.getDefaultEntity(),
    }
  },

  created() {
    this.entity = this.id ? _.cloneDeep(this.$store.getters['sites/getEntity'](this.tag, this.id)) : 
      this.getDefaultEntity();
  },

  methods: {
    async save() {
      this.$refs.form.validate();
      if (this.isValid) {
        // Если есть проверка на уровне Сущности - запускаем ее
        if (this.validateFunc) {
          let result = this.validateFunc();
          //console.log(result);
          if (!result) {
            return false;
          }
        }
        return this.$store.dispatch('sites/saveEntity', {
          tag: this.tag,
          entity: this.entity
        })
        .then(res => {
          this.$store.dispatch('showMessage', res.message);
          return true;
        })
        .catch(err => {
          this.$store.dispatch('showMessage', err.message);
          return false;
        });
      } else {
        return false;
      }
    },
    restoreEntity() {
      this.entity = this.id ? _.cloneDeep(this.$store.getters['sites/getEntity'](this.tag, this.id)) : 
        this.getDefaultEntity();
      this.$refs.form.resetValidation();
    }
  },

  computed: {
    loading() {
      return this.$store.getters['sites/loadingEntity'](this.tag, 'save');
    },
    ...mapGetters('sites', ['sitesSelectData'])
  }
}